import type { SxProps, Theme } from '@mui/material/styles';

export const TALL_CARD_HEIGHT = 280;
export const SMALL_CARD_HEIGHT = 132;
export const HERO_GRID_SX: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: 'repeat(4, minmax(0, 1fr))' },
  gap: '16px',
};
export const CARD_TITLE_SX: SxProps<Theme> = {
  fontSize: 14,
  fontWeight: 600,
  color: 'text.primary',
};
